import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";

export const searchAddressApi = createApi({
  reducerPath: "searchUserAddressApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getUserAddress: builder.query<any, string>({
      query: (userSearchAddress) => ({
        url: "/map/search",
        params: { search: userSearchAddress },
        method: "GET",
      }),
    }),
    postDropOffProxy: builder.mutation<
      any,
      { longitude: string; latitude: string; radius?: string }
    >({
      query: (dropOffData) => ({
        url: "/drop-offs/proxy",
        method: "POST",
        body: dropOffData,
      }),
    }),
  }),
});

export const { useGetUserAddressQuery, usePostDropOffProxyMutation } =
  searchAddressApi;
